import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { loginStoreActions } from '@app/root-store';
import { Router } from '@angular/router';
import { AuthService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'my-delivery-header',
  templateUrl: './my-delivery-header.component.html',
  styleUrls: ['./my-delivery-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyDeliveryHeaderComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  _currentUser;
  constructor(private _router: Router, private _toastr: ToastrService, private _authService: AuthService, private _store: Store) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((data) => {
        if (data) {
          this._currentUser = data;
        }
      })
    );
  }
  logout(): void {
    const logoutURL = this._currentUser.user_type === UserTypeEnum.Professional ? '/' : '/';
    this.subscription.add(
      this._authService.logoutWithGuardianCheck().subscribe(
        () => {
          // logout dispacth Ngrx
          this._store.dispatch(new loginStoreActions.LogoutSuccessAction());
          this._router.navigate([logoutURL]);
        },
        (error: any) => {
          this._toastr.error(error.error.message);
          return false;
        }
      )
    );
  }
}
